import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useManuscripts } from './ManuscriptContext';
import './ManuscriptMetadata.css';

const ManuscriptMetadata = () => {
  const { id: manuscriptId } = useParams();
  const { getManuscriptById, loading, error } = useManuscripts();
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    if (!loading) {
      const msData = getManuscriptById(manuscriptId);
      setMetadata(msData);
    }
  }, [manuscriptId, getManuscriptById, loading]);

  // No need for folio calculation - we just use the start_folio from metadata

  if (loading) {
    return (
      <div className="container">
        <div className="main">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <div className="loading-text">Loading manuscript details...</div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="text-center p10 highlight">{error}</div>;
  }

  if (!metadata) {
    return <div className="text-center p10">Manuscript not found</div>;
  }

  // Use the start_folio from metadata for linking
  const firstFolio = metadata.start_folio;

  return (
    <div className="container">
      <div className="main">
        <div className="manuscript-detail">
          <div className="manuscript-titles">
            <h2 className="title-ar" dir="rtl">
              {metadata.section && (
                <div>{metadata.section} من</div>
              )}
              {metadata.title_ar}
            </h2>
            <h3 className="title-lat">{metadata.title_lat}</h3>
          </div>
          <div className="manuscript-content">
            <div className="manuscript-image">
              <img
                src={`/msdata/${metadata.manuscript_id}/img/1.jpg`}
                alt={`First folio of ${metadata.title_lat}`}
              />
            </div>
            <div className="manuscript-info">
              <div className="description-section">
                <h3>Description</h3>
                <p>{metadata.description}</p>
              </div>
              <div className="description-section">
                <h3>Issues</h3>
                <p>{metadata.issues}</p>
              </div>
              <div className="metadata-grid">
                <div className="metadata-item">
                  <h4>Author</h4>
                  <p dir="ltr" className="arabic-text">{metadata.author_lat}</p>
                  <p dir="ltr" className="arabic-text">{metadata.author_ar}</p>
                </div>
                <div className="metadata-item">
                  <h4>Death Date</h4>
                  <p>{metadata.date}</p>
                </div>
                <div className="metadata-item">
                  <h4>Language</h4>
                  <p>{metadata.language}</p>
                </div>
                <div className="metadata-item">
                  <h4>Library</h4>
                  <p>{metadata.library}</p>
                </div>
                <div className="metadata-item">
                  <h4>Shelfmark</h4>
                  <p>{metadata.collection_name}</p>
                </div>
                <div className="metadata-item">
                  <h4>Folios</h4>
                  <p>{metadata.start_folio}-{metadata.end_folio}</p>
                </div>
                <div className="metadata-item">
                  <h4>Published</h4>
                  <p>{metadata.published}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="manuscript-titles">
            <div className="viewer-link">
              <Link to={`/viewer/${metadata.manuscript_id}/${firstFolio}`} className="button">
                Open in Viewer
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManuscriptMetadata;